import uniqId from 'uniq-id';

export default {
    addMessage: ({ commit, state }, message) => {
        const alreadyExistMessage = state.messages.find(it => {
            let equal = true;

            Object.keys(message).forEach(key => {
                if (it[key] && it[key] != message[key]) {
                    equal = false;
                }
            });

            return equal;
        });

        if (alreadyExistMessage) {
            commit('alert/REMOVE_MESSAGE', alreadyExistMessage.id, { root: true });
        }

        const messageObj = Object.assign({ id: uniqId(), time: 2000 }, message);

        commit('alert/ADD_MESSAGE', messageObj, { root: true });

        setTimeout(() => commit('alert/REMOVE_MESSAGE', messageObj.id, { root: true }), messageObj.time);
    }
};
